export default __webpack_public_path__ + "static/media/Apple-AppStore-logo.cf0dcd5f.png";